import React from "react";


const EventCalendarCompaign = ({ eventsItems }) => {


	return (
		<div className="marketing__content cts-container">
          	<h2 className="feature-heading text-capitalize text-center">Event Calendars Campaign</h2>
          	<div className="marketing__content__events justify-content-center">
      		  	{/* Sidebar start */}
		         <div className="marketing__content__events__sidebar w-75">
		         	{(eventsItems.length > 0 ) ? (
			   		    <div className="event-header">
		            	    <h2 className="title">Select One Event</h2>
		            	</div>
		         	) : (
						<div className="event-header">
		            	    <h2 className="title text-center">All events are already promoted to event calendars.</h2>
		            	</div>
		         	)}

		            <div className="events_container">
		              {eventsItems.map((event, index) => (
		                  <div
		                    className={`events_container__item`}
		                    key={index}
		                    onClick={() => window.location.href = `/events/${event.id}/promote`}
		                  >
		                    <img
		                      src={event.banner_image}
		                      alt="event"
		                      width="76"
		                      height="46"
		                    />
		                    <div>
		                      <h4 className="text-ellipse">{event.name}</h4>
		                      <span>{event.event_address}</span> |{" "}
		                      <span className="ml-1">{event?.start_date}</span>
		                    </div>
		                  </div>
		                ))
		  			  }
		            </div>


		         </div>
          		{/* Sidebar end */}

			</div>
		</div>
	)

}

export default EventCalendarCompaign;
